// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://pyramid-health.rrodriguez-938.workers.dev';

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    chat: '/api/chat',
    health: '/api/health',
    dashboard: '/api/analytics/dashboard',
    testBot: '/api/test-health-bot',
    quickAction: '/api/quick-action'
  }
};

export default apiConfig;